import React from 'react';

const Grid = ({ 
    children, 
    columns = 'repeat(auto-fit, minmax(250px, 1fr))', 
    gap = '1rem', 
    rows,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <div 
            className={className} 
            style={{ 
                display: 'grid',
                gridTemplateColumns: columns,
                gridTemplateRows: rows,
                gap: gap,
                ...style 
            }}
            {...props}
        >
            {children}
        </div>
    );
};

export default Grid;

